import React from 'react';
import Icon from '../../../components/AppIcon';

const InvoiceGenerationDashboard = ({ stats }) => {
  const statCards = [
    {
      title: 'Total Invoices',
      value: stats?.totalInvoices || 0,
      icon: 'FileText',
      color: 'text-blue-600',
      bgColor: 'bg-blue-50',
      description: 'All time'
    },
    {
      title: 'Pending Invoices',
      value: stats?.pendingInvoices || 0,
      icon: 'Clock',
      color: 'text-yellow-600',
      bgColor: 'bg-yellow-50',
      description: 'Awaiting payment'
    },
    {
      title: 'Completed',
      value: stats?.completedInvoices || 0,
      icon: 'CheckCircle',
      color: 'text-green-600',
      bgColor: 'bg-green-50',
      description: 'Paid invoices'
    },
    {
      title: 'Failed',
      value: stats?.failedInvoices || 0,
      icon: 'XCircle',
      color: 'text-red-600',
      bgColor: 'bg-red-50',
      description: 'Payment failed'
    },
    {
      title: 'Total Revenue',
      value: `$${(stats?.totalRevenue || 0)?.toFixed(2)}`,
      icon: 'DollarSign',
      color: 'text-primary',
      bgColor: 'bg-primary/10',
      description: 'From completed'
    },
    {
      title: 'Pending Amount',
      value: `$${(stats?.pendingAmount || 0)?.toFixed(2)}`,
      icon: 'TrendingUp',
      color: 'text-orange-600',
      bgColor: 'bg-orange-50',
      description: 'Expected revenue'
    }
  ];

  return (
    <div className="mb-6">
      <h2 className="text-xl font-heading font-semibold text-foreground mb-4">
        Invoice Overview
      </h2>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-6 gap-4">
        {statCards?.map((stat, index) => (
          <div
            key={index}
            className="bg-card border border-border rounded-lg p-4 hover:shadow-md transition-shadow"
          >
            <div className="flex items-start justify-between mb-3">
              <div className={`p-2 rounded-lg ${stat?.bgColor}`}>
                <Icon name={stat?.icon} size={20} className={stat?.color} />
              </div>
            </div>
            <p className="text-2xl font-bold text-foreground mb-1">
              {stat?.value}
            </p>
            <p className="text-sm font-medium text-foreground mb-1">
              {stat?.title}
            </p>
            <p className="text-xs text-muted-foreground">
              {stat?.description}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default InvoiceGenerationDashboard;